import request from "../../../../../../utils/api";

let conversion = "point_convertions";

export const getPointConversion = body => request(`${conversion}?page=${body.paginate}`);
export const postPointConversion = body => request(`${conversion}`, { method: 'post', body })
export const putPointConversion = body => request(`${conversion}/${body.point_convertion.id}`, { method: 'put', body });
export const deletePointConversion = body => request(`${conversion}/${body}`, { method: 'delete' });

